Vendd.Scripts.load(function () {
 
    var $boxes = $('.x-category-detailed-box');
    
    if ($boxes.length <= 0)
        return;

    if (isTouch()) {
        initListToggle();
    }

    var iconOpen = $boxes.first().data('open-icon');
    var iconClose = $boxes.first().data('close-icon');

    if($boxes.closest('.x-category-banners').length > 0){
        $boxes.each(function(){
            if ($('.subcategory-list > li', $(this)).length > 8){
                $('.subcategory-list > li.view-all', $(this)).addClass('show');
            }
        });
    }

    function initListToggle() {
        $(".js-toggle", $boxes).click(function () {
            var hiddenCont = $(this).siblings('.js-content-accord');
            $(this).toggleClass(iconOpen + " " + iconClose);
            if (hiddenCont.hasClass('opened')) {
                hiddenCont.removeClass('opened');
            } else {
                $boxes.find('.opened').removeClass('opened').siblings('.js-toggle').toggleClass(iconOpen + " " + iconClose);
                hiddenCont.addClass('opened');
            }
        });
    
        var accordion = false;
    
        if ($(window).width() <= 767) {
            accordion = true;
        }
    
        $(window).resize(function () {
            if ($(window).width() > 767) {
                if (accordion) {
                    $('.js-content-accord', $boxes).removeClass('opened');
                    accordion = false;
                }
            }
            else {
                if (!accordion) {
                    $('.js-content-accord', $boxes).siblings('.js-toggle').toggleClass(iconOpen + " " + iconClose);
                    accordion = true;
                }
            }
        });
    }

});